import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from './services/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  public loggedIn: boolean;
  private Subscriptions: Subscription[] = [];

  constructor(private Auth: AuthService) {}

  ngOnInit() {
    this.Subscriptions.push(
      this.Auth.loggedIn.subscribe((loggedIn) => (this.loggedIn = loggedIn)),
    );
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }

  logout() {
    this.Auth.logout();
  }
}
